import '@/app/app.css';
import './vacancy.css';
import '@/app/app';

import { initVacanciesOfferSlider } from '@/templates/vacancies/sections/vacancies-offer/vacancies-offer';
import { initEventSectionHeader } from '@/features/events/event-section/init-event-section-header';

window.addEventListener('DOMContentLoaded', () => {
	initVacanciesOfferSlider();
	initEventSectionHeader();
});
